import React from "react"
import { View, ViewStyle } from "react-native"

import { Image, ImageStyle } from "expo-image"

export const CrisisLineThumbnail: React.FC = () => {
  return (
    <View style={$container}>
      <Image
        source={require("./veterans-crisis-line-logo.png")}
        style={$image}
        contentFit="contain"
      />
    </View>
  )
}

const $container: ViewStyle = {
  justifyContent: "center",
  alignItems: "center",
}

const $image: ImageStyle = {
  width: 180,
  height: 80,
}
